(function () {
  var root = document.querySelector('[data-ilmas-header]');
  if (!root) return;
  var btn = root.querySelector('[data-ilmas-burger]');
  var isPt = (document.documentElement.lang || '').toLowerCase().indexOf('pt') === 0;

  function t(es, pt) {
    return isPt ? pt : es;
  }

  function localizeHref(href) {
    if (!isPt || !href || href.charAt(0) !== '/' || href.indexOf('//') === 0) return href;
    if (/^\/pt(?:\/|$|\?|#)/.test(href)) return href;
    if (/^\/(?:admin|checkout|cdn|tools)(?:\/|$)/.test(href)) return href;
    if (href === '/') return '/pt';
    return '/pt' + href;
  }

  function localizeLinks(scope) {
    (scope || document).querySelectorAll('a[href]').forEach(function (link) {
      var href = link.getAttribute('href');
      var localized = localizeHref(href);
      if (localized !== href) link.setAttribute('href', localized);
    });
  }

  function closeItem(el) {
    el.classList.remove('is-open');
    var trigger = el.querySelector('[data-ilmas-nav-parent]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function closeAllItems() {
    root.querySelectorAll('.ilmas-hdr__item.is-open').forEach(closeItem);
  }

  function openItem(item) {
    if (!item) return;
    closeAllItems();
    item.classList.add('is-open');
    var trigger = item.querySelector('[data-ilmas-nav-parent]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  function onBurgerClick() {
    var open = root.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.setAttribute('aria-label', open ? t('Cerrar menú', 'Fechar menu') : t('Abrir menú', 'Abrir menu'));
    if (!open) closeAllItems();
  }

  function closeMenu(restoreFocus) {
    root.classList.remove('is-open');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-label', t('Abrir menú', 'Abrir menu'));
    closeAllItems();
    if (restoreFocus) btn.focus();
  }

  function isMobileNav() {
    return window.matchMedia('(max-width: 900px)').matches;
  }

  function onParentClick(e) {
    if (!isMobileNav()) return;
    var link = e.currentTarget;
    var item = link.closest('.ilmas-hdr__item');
    if (!item || !item.classList.contains('has-children')) return;
    e.preventDefault();
    var open = !item.classList.contains('is-open');
    if (open) openItem(item);
    else closeItem(item);
  }

  function bindParent(link) {
    link.addEventListener('click', onParentClick);
    var item = link.closest('.ilmas-hdr__item');
    if (!item) return;
    item.addEventListener('mouseenter', function () {
      if (!isMobileNav()) openItem(item);
    });
    item.addEventListener('mouseleave', function () {
      if (!isMobileNav()) closeItem(item);
    });
    item.addEventListener('focusin', function () {
      if (!isMobileNav()) openItem(item);
    });
    item.addEventListener('focusout', function (event) {
      if (!isMobileNav() && !item.contains(event.relatedTarget)) closeItem(item);
    });
  }

  if (btn) btn.addEventListener('click', onBurgerClick);
  if (btn) btn.setAttribute('aria-label', t('Abrir menú', 'Abrir menu'));
  localizeLinks(document);
  if (isPt && window.MutationObserver) {
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;
          if (node.matches && node.matches('a[href]')) {
            var href = node.getAttribute('href');
            node.setAttribute('href', localizeHref(href));
          }
          localizeLinks(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
  root.querySelectorAll('[data-ilmas-nav-parent]').forEach(bindParent);
  root.querySelectorAll('.ilmas-hdr__drop a, .ilmas-hdr__btn').forEach(function (link) {
    link.addEventListener('click', function () {
      if (isMobileNav()) closeMenu(false);
    });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (root.classList.contains('is-open')) closeMenu(true);
    else closeAllItems();
  });
  window.addEventListener('resize', function () {
    if (!isMobileNav()) closeMenu(false);
    else closeAllItems();
  });
})();
